var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Assets","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"icon/star"},[React.createElement("mask",{"id":"mask-2","fill":"white","key":0},React.createElement("polygon",{"id":"path-1","points":"8.90994557 8.2611331 2 9.26558634 7 14.1394112 5.81927264 21.0209055 12 17.7718951 18.1801089 21.0209055 17 14.1394112 22 9.26558634 15.0900544 8.2611331 12 2"})),React.createElement("polygon",{"id":"a","stroke":"#333333","strokeLinecap":"round","strokeLinejoin":"round","points":"8.90994557 8.2611331 2 9.26558634 7 14.1394112 5.81927264 21.0209055 12 17.7718951 18.1801089 21.0209055 17 14.1394112 22 9.26558634 15.0900544 8.2611331 12 2","key":1})])));
}

Star.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Star;

Star.default = Star;
